// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormEmbeddedReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import ReportPartFormUtils from 'logic/models/Izenda.ReportPartFormUtils';
import ReportBodyConstants from 'logic/data/Izenda.ReportBodyConstants';
import { chain, isArray, isObject, uniqueId } from 'lodash/fp';

export default class ReportPartFormEmbeddedReport {
  /**
   * Insert Embedded Report HTML
   * @param  {Array} List data of report part object
   * @return {String} embedded report html
   */
  @action
  insertEmbeddedReportHtml(data: any, editorControl: any) {
    const { id, name } = data.selectedReport;
    const embedReportHtml = chain(data.selectedReport.selectedReportParts)
      .map(
        reportPart =>
          `<embedded-report id="${id}" class="field-wrapper" data-width="${reportPart.width * ReportBodyConstants.BODY_CELL_WIDTH}" data-height="${reportPart.height * ReportBodyConstants.BODY_CELL_HEIGHT}"><span class="icon-attached"></span>${name}/${reportPart.title}</embedded-report>`
      )
      .join('')
      .value();

    editorControl.insertContent(embedReportHtml);
  }

  /**
   * Update Embedded Report HTML
   * @param  {Array} List data of report part object
   */
  updateEmbeddedReportHtml(embeddedReportDOM: any, model: any) {
    this.insertEmbeddedReportHtml(model);
  }

  /**
   * Get embedded report html
   * @param {String} html
   * @returns {Object} { htmlContent, embeddedReports }
   */
  generateEmbeddedReport(embeddeReportData: any, htmlContent: string) {
    const embeddedReportDoms = $izenda('<div>' + htmlContent + '</div>')
      .find('embedded-report')
      .toArray();
    const embeddedReports = [];

    return Promise.each(embeddedReportDoms, (er, index) => {
      const emId = $izenda(er).attr('id');
      let emContent = $izenda(er).text();
      if ($izenda(er).html()) {
        const matches = $izenda(er)
          .html()
          .match(/(<\/span>)(.+)/);
        isArray(matches) && (emContent = matches.pop());
      }
      return ReportPartFormUtils.validateEmbeddedReport(emId, emContent, embeddeReportData).then(result => {
        const data = $izenda(er).data();
        const width = data.width;
        const height = data.height;
        const embeddedReportHtml = $izenda(er).get(0).outerHTML;

        if (isObject(result)) {
          const reportPartObject = this.getSubReportObject(result, index);
          reportPartObject.width = width;
          reportPartObject.height = height;
          reportPartObject.index = htmlContent.indexOf(embeddedReportHtml);

          const divText = `<div class="u_fullWidth ${reportPartObject.reportPartDomId}"></div>`;
          embeddedReports.push(reportPartObject);

          htmlContent = htmlContent.replace(embeddedReportHtml, divText);
        } else {
          htmlContent = htmlContent.replace(embeddedReportHtml, result);
        }
      });
    }).then(() => ({
      htmlContent,
      embeddedReports
    }));
  }

  /**
   * Get subReport object for embedded ReportPart
   * @return {Object} subReportObject
   */
  getSubReportObject(result: Array<any>, index: number) {
    const embeddedReportPartId = ['EmbededReportPart', index, result.reportPartId, uniqueId('_subreport')].join('_');

    return {
      id: result.reportPartId,
      reportPartDomId: embeddedReportPartId
    };
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportPartFormEmbeddedReport.js